export enum EStandard {
    telemetry = 'telemetry',
    sdCard = 'sdCard',
    simulator = 'simulator',
}
